/**
 * Языки
 */
export const LANGS = [
  {
    id: 'en',
    name: 'English'
  },
  {
    id: 'ru',
    name: 'Русский'
  }
]